import type {HTMLChakraProps, NumberInputProps} from '@chakra-ui/react';
import {faChevronDown} from '@fortawesome/pro-solid-svg-icons/faChevronDown';
import {faChevronUp} from '@fortawesome/pro-solid-svg-icons/faChevronUp';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';

import {
  NumberInput,
  forwardRef,
  NumberDecrementStepper,
  NumberIncrementStepper,
  NumberInputField,
  NumberInputStepper,
} from '@chakra-ui/react';

export type EditableNumberInputProps = Omit<NumberInputProps, 'onChange'> &
  HTMLChakraProps<'input'> & {
    draft?: string;
    isEditing?: boolean;
  };

export const EditableNumberInput = forwardRef<EditableNumberInputProps, 'input'>((props, ref) => {
  const {sx: inputSx, onChange, ...rest} = props;

  return (
    // TODO: figure out how to handle width considering the original structure
    <NumberInput
      {...rest}
      sx={inputSx}
      maxW={`60px`}
      ref={ref}
      value={rest.isEditing ? rest.draft : rest?.value}
      // @ts-expect-error: TODO: fix this
      onChange={value => onChange?.({target: {value}})}
    >
      <NumberInputField
        fontWeight={`bold`}
        sx={{bgColor: inputSx?.bg}}
        {...props}
        placeholder={rest.isEditing ? `${rest.draft ?? ``}` : `${rest?.value ?? ``}`}
      />
      <NumberInputStepper>
        <NumberIncrementStepper children={<FontAwesomeIcon width={`8px`} icon={faChevronUp} />} />
        <NumberDecrementStepper children={<FontAwesomeIcon width={`8px`} icon={faChevronDown} />} />
      </NumberInputStepper>
    </NumberInput>
  );
});

EditableNumberInput.displayName = `EditableNumberInput`;
